import { Link } from 'react-router-dom';
import { useLanguage } from '../lib/i18n';
import { Globe, BookOpen, Mail, MapPin } from 'lucide-react';
import { OFALogo } from './OFALogo';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="site-footer" className="bg-[#14274B] text-white">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          <div className="lg:col-span-1">
            <OFALogo variant="light" className="h-16 mb-6" />
            <p className="text-sm text-slate-300 leading-relaxed max-w-xs">{t('footer.desc')}</p>
            <div className="flex items-center gap-2 mt-6 text-sm text-slate-400">
              <Globe className="w-4 h-4" />
              <span>{t('footer.global')}</span>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-6 text-white">{t('footer.academy')}</h4>
            <div className="flex flex-col gap-3">
              <Link to="/vision" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('nav.vision')}</Link>
              <Link to="/programs" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('nav.programs')}</Link>
              <Link to="/certificates" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('nav.certificates')}</Link>
              <Link to="/educators" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('nav.educators')}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-6 text-white">{t('footer.community')}</h4>
            <div className="flex flex-col gap-3">
              <Link to="/contribute" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('footer.teachContribute')}</Link>
              <a href="https://ofalycee.org" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('footer.school')}</a>
              <a href="https://blog.ofalycee.org" target="_blank" rel="noopener noreferrer" data-testid="footer-blog-link" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('footer.blog')}</a>
              <Link to="/login" className="text-sm text-slate-300 hover:text-[#2D78F6] transition-colors duration-200">{t('footer.studentPortal')}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold tracking-widest uppercase mb-6 text-white">{t('footer.contact')}</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 text-sm text-slate-300"><Mail className="w-4 h-4 text-[#F8CD46]" /><span>academy@ofalycee.org</span></div>
              <div className="flex items-center gap-2 text-sm text-slate-300"><MapPin className="w-4 h-4 text-[#926EF7]" /><span>{t('footer.globalOnline')}</span></div>
              <div className="flex items-center gap-2 text-sm text-slate-300"><BookOpen className="w-4 h-4 text-[#2D78F6]" /><span>{t('footer.bilingual')}</span></div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p data-testid="footer-trademark" className="text-xs text-slate-400 text-center md:text-left">OFA Academy™ is an educational initiative and trademark of OFALycée™. &copy; {new Date().getFullYear()} OFALycée™. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-xs text-slate-400 hover:text-white transition-colors duration-200">{t('footer.privacy')}</Link>
            <Link to="/terms" className="text-xs text-slate-400 hover:text-white transition-colors duration-200">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
